import {Component, Inject} from '@angular/core';
import {FormControl, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';

@Component(
    {selector: 'add-admin-dialog', templateUrl: './add-admin-dialog.html'})
export class AddAdminDialogComponent {
  email = new FormControl('', [
    Validators.required,
    Validators.pattern(
        '^[a-z0-9!#$%&\'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$')
  ]);
  name = new FormControl('', [Validators.required]);

  constructor(
      public dialogRef: MatDialogRef<AddAdminDialogComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) {}

  getErrorMessage() {
    return this.email.hasError('required') ?
        'You must enter an email' :
        this.email.hasError('pattern') ? 'Not a valid email' : '';
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}



// WEBPACK FOOTER //
// /tmp/build_f0fbff5b/src/app/main/content/organisations/admin/add.admin.dialog.component.ts